import { motion } from 'framer-motion';
import Button from '../../Button';
import BustExplaining from '../../../public/images/busts/bustExplaining.svg';
import PlaceholderText from '../../../public/images/placeholderText.svg';
import PlaceholderHead from '../../../public/images/placeholderHead.svg';
import styles from '../../../styles/modules/promotion/referral/ReferralIntro.module.scss';

const ReferralIntro = () => {
  return (
    <section className={['block', 'crop'].join(' ')}>
      <div className="fixed">
        <div className={styles.intro}>
          <div className={styles.introPlaceholder}>
            <PlaceholderHead className={styles.introPlaceholderHead} />
            <motion.div
              initial={{ rotate: '0deg' }}
              animate={{ rotate: '-360deg' }}
              transition={{ repeat: Infinity, repeatType: 'loop', duration: 15, ease: 'linear' }}
            >
              <PlaceholderText />
            </motion.div>
          </div>
          <div className={styles.introContent}>
            <div className={styles.introContentTitle}>
              Приглашай друзей в «ЛЕНДЛОРД» и зарабатывай
            </div>
            <div className={styles.introContentDescription}>
              Получи <span className={styles.bold}>до 5 000 ₽</span> за друга оформившего сделку у
              нас, а мы ему <span className={styles.bold}>скидку 25%</span> на услуги компании
            </div>
            <Button className={styles.introContentButton} type="link" href="#about">
              Подробнее об акции
            </Button>
          </div>
          <div className={styles.introAbstract}>
            <motion.div
              transition={{ delay: 0.2 }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className={styles.introAbstractItem}
            >
              <BustExplaining />
            </motion.div>
            <motion.div
              transition={{ delay: 1 }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.4 }}
              className={[styles.introAbstractShadow, styles.big].join(' ')}
            >
              ₽
            </motion.div>
            <motion.div
              transition={{ delay: 1.5 }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.8 }}
              className={[styles.introAbstractShadow, styles.medium].join(' ')}
            >
              ₽
            </motion.div>
            <motion.div
              transition={{ delay: 2 }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.6 }}
              className={[styles.introAbstractShadow, styles.small].join(' ')}
            >
              %
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReferralIntro;
